export const business = [
  {
    id: 1,
    firstName: "Alric",
    lastName: "Truelock",
    displayName: "BB Vietnamese street food",
    email: "atruelock0@skype.com",
    gender: "Bigender",
    avatar:
      "https://lokalai-menu.s3.ap-southeast-2.amazonaws.com/logoBeBau.jpg",
    bgImage:
      "https://lokalai-menu.s3.ap-southeast-2.amazonaws.com/coverbebau.png",
    count: 40,
    // href: "/operator/menu/65d6b639bb1369f6006dd3ee",
    href: "/author/bb-vietnamese-street-food",

    desc: "There’s no stopping the tech giant. Apple now opens its 100th store in China.There’s no stopping the tech giant.",
    jobName: "Street Food",
  },
  {
    id: 2,
    firstName: "Chariot",
    lastName: "Birrell",
    displayName: "Little Vietnam Christchurch",
    email: "cbirrell1@google.com.hk",
    gender: "Genderfluid",
    avatar:
      "https://lokalai-menu.s3.ap-southeast-2.amazonaws.com/littlelogo.jpg",
    count: 115,
    href: "/author/little-vietnam-christchurch",
    desc: "There’s no stopping the tech giant. Apple now opens its 100th store in China.There’s no stopping the tech giant.",
    jobName: "Food court",
    bgImage:
      "https://lokalai-menu.s3.ap-southeast-2.amazonaws.com/littleCover.jpg",
  },
  {
    id: 3,
    firstName: "Nathanil",
    lastName: "Foulcher",
    displayName: "Royal Vietnamese Café & Restaurant",
    email: "nfoulcher2@google.com.br",
    gender: "Bigender",
    avatar: "https://lokalai-menu.s3.ap-southeast-2.amazonaws.com/royal.jpg",
    count: 43,
    href: "/author/royal-vietnamese-cafe-and-restaurant",
    desc: "There’s no stopping the tech giant. Apple now opens its 100th store in China.There’s no stopping the tech giant.",
    jobName: "Restaurant",
    bgImage:
      "https://lokalai-menu.s3.ap-southeast-2.amazonaws.com/royal%2Bbg.jpg",
  },
];

export const booking = [
  {
    id: 1,
    firstName: "Alric",
    lastName: "Truelock",
    displayName: "Diamond Nail Blemheim",
    email: "atruelock0@skype.com",
    gender: "Bigender",
    avatar: "/image/diamond_logo2.png",
    bgImage: "/image/nail_hero.jpg",
    count: 220,
    href: "/author/diamond-nails",
    desc: "There’s no stopping the tech giant. Apple now opens its 100th store in China.There’s no stopping the tech giant.",
    jobName: "Nail Salon",
  },
];

export const loyalty = [
  // {
  //   id: 1,
  //   firstName: "Alric",
  //   lastName: "Truelock",
  //   displayName: "Saigon Stars",
  //   email: "atruelock0@skype.com",
  //   gender: "Bigender",
  //   avatar: "/image/sg.webp",
  //   bgImage: "/image/cover.webp",
  //   count: 40,
  //   href: "/operator/menu/65d6b639bb1369f6006dd3ee",
  //   desc: "There’s no stopping the tech giant. Apple now opens its 100th store in China.There’s no stopping the tech giant.",
  //   jobName: "Restaurant",
  // },
  {
    id: 1,
    firstName: "Alric",
    lastName: "Truelock",
    displayName: "Rollicous Vietnamese",
    email: "atruelock0@skype.com",
    gender: "Bigender",
    avatar:
      "https://globalmira.s3.ap-southeast-2.amazonaws.com/logoRollicious.png",
    bgImage:
      "https://globalmira.s3.ap-southeast-2.amazonaws.com/rolliciouscover2.jpg",
    count: 40,
    href: "/author/rollicous",
    desc: "We're passionate about bringing fresh, healthy, and delicious Vietnamese food to your table. Savor our North-style Beef Pho, freshly baked in-house Banh Mi, and nine reinvented fresh spring rolls. Every dish is a labor of love, celebrating the rich heritage of Vietnamese cuisine",
    jobName: "Food Truck",
  },
];
